module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('em', [_vm._v("Prologue")])])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "nonindentc"
  }, [_c('em', [_vm._v("Detroit, Michigan")]), _c('br'), _c('em', [_vm._v("July 13, 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Sweat ran down the middle of six-year-old China Brown’s forehead as she crouched in the cool, dry dirt beneath the porch of her mother’s house. Inside, she could hear the murmur of voices and the occasional thud of footsteps as her mother and her stepfather, Clyde, moved from room to room. Every time she heard Clyde’s voice she shuddered. It was only a matter of time before he realized his favorite coffee cup was broken. She hadn’t meant to do it, but Clyde wouldn’t care that it was an accident. He didn’t like her any more than she liked him and seemed to look for reasons to reprimand her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Time passed, and she had almost drifted off to sleep when she heard a loud, angry shout, then the sound of running footsteps coming toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“China Mae, you get in here right now!” Clyde yelled.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("China flinched. He must have found the cup. She’d ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("wanted to hide the pieces, but she’d heard her mother coming and had tossed them into the wastebasket before bolting out the door. Now it was too late. They’d been found.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“China… so help me God, I’m gonna whip your ass if you don’t answer me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China held her breath. Answer Clyde? No way. He was gonna whip her ass no matter what. Why hurry up the inevitable?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She heard another pair of footsteps—lighter, quicker—then the anxious tone of her mother’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Clyde? What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde Shubert pivoted angrily, jamming a knobby finger into the woman’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll tell you what’s wrong. That stupid kid of yours broke my favorite coffee cup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China heard her mother’s swift intake of breath and just for a moment thought about revealing herself. Sometimes Clyde took his anger out on her mother, too. But her fear was greater than her guilt, and she stayed immobile, closing her eyes and praying as she’d never prayed before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure it was an accident,” Mae offered, and tried to placate Clyde with a pat on his arm.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("But Clyde would have none of it. He shrugged off Mae’s touch and cursed aloud before striding to the edge of the porch. China followed his path with a horrified gaze, watching the dirt sift down through loose wooden planks above her head, then blinking furiously when some of the dirt drifted into her eyes. Suddenly ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("her nose began to tickle, and she pinched it between her thumb and forefinger, willing herself not to sneeze.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“China! You get yourself into the house this instant!” Clyde yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China pinched her nose tighter as the urge to sneeze persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please… Clyde… it’s just a cup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sound of flesh hitting flesh was as abrupt as China’s exit from the house had been, and she knew without doubt that her mother had just been slapped. The need to sneeze disappeared, replaced by an overwhelming urge to cry. She did neither, instead curling tighter into a ball and wishing she could disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Today a cup. Tomorrow something else. You’re always excusing the little bitch. That’s what’s wrong with her!” he yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae flinched, but held her head high. It wasn’t the first time he’d hit her. Doubtless it wouldn’t be the last. There were days when it shamed her that she’d let herself come to this, but she didn’t have the guts to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t call my daughter names. There’s nothing wrong with her! She’s just a little girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde snorted beneath his breath. “Yeah, and one of the skinniest, ugliest kids I’ve ever seen. You just keep her out of my face, you hear me?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("China bit her lip as she heard Clyde stomp back into the house. Ugly? She was ugly? Tears welled. She didn’t want to be ugly. Her thoughts began to race. Was that why she didn’t have any friends? Did the ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("kids down the street think she was too ugly to play with?")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“China… where are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae’s voice startled her, and she almost answered. But a sense of self-preservation kept her quiet, and moments later she heard her mother go back inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as she knew she was alone, she rolled over onto her stomach and buried her face in her arms. Ugly. She hadn’t known she was ugly. Now it made sense why Clyde didn’t like her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hot tears welled beneath her eyelids as she lay belly down in the dirt and buried her face in the curve of her arm, her thin little shoulders shaking with suppressed sobs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The neighbor’s yellow cat sauntered into their yard and started beneath the porch, then stopped short, hissing with displeasure as it saw China. Ordinarily she would have jumped and run away, but today she didn’t care. Nothing mattered anymore, not even the chance that old Scruffy might scratch her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cat sniffed her bare feet, then the backs of her knees, then worked its way up to her face, sniffing and licking at the wash of wet, salty tears streaming down the side of China’s cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gasped and jerked, raising her head too fast and bumping it on the underside of the porch. Scruffy hissed at the unexpected movement and scampered out the other side of the porch to disappear beneath a volunteer stand of Castor beans her mother let grow to keep the moles and gophers out of the yard.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("China held her breath, certain that the thump of her head against the underside of the porch had given her away, but when no one came running, she began to relax.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Scruffy seemed to have forgiven her for frightening him and was already in the act of stalking a grasshopper that had landed on a nearby blade of grass. The big cat pounced, and she absently watched the demise of the grasshopper as it disappeared down Scruffy’s throat. The cat soon moved on in search of bigger game, leaving China alone with a sense of growing dread. Sooner or later it was bound to get dark, and when it did, she would have to come out. It was a sad but true fact that she was more afraid of the dark than she was of Clyde.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shuddered on a sob, then wiped her nose on the back of her hand and started inching her way through the dust toward the yard beyond. Just as she reached the edge of the porch, a small brown caterpillar dropped from a blade of grass and began inching its way toward the shade beneath the porch. China hesitated, then rested her chin on her hands, watching in fascination at the undulant movement of the tiny body—at the way it seemed to thread itself between the twigs and pebbles without disturbing a single grain of dust. It was so small. If she hadn’t been eye to eye with the little creature, she would never have known it was there.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("As she watched, a thought began to occur. If only she could become as small and insignificant as the ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("lowly little worm, then maybe Clyde would never bother her again. And if she was as ugly as Clyde said she was, being invisible would protect her from offending people with her presence. It seemed like a good idea, and she even closed her eyes and tried to think herself small. But when she finally looked up, she was still China and the caterpillar was gone. She crawled out from under the porch and began dusting off the front of her clothes. Some things just weren’t meant to be.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She made herself scarce for the rest of the afternoon until the sun began to set. Then, when the shadows in the yard began to lengthen and turn a dark, somber blue, she dawdled through the grass to the front steps and sat, waiting until the last possible minute before going inside to face Clyde’s wrath. The hinges suddenly squeaked on the screen door behind her, and she jumped and stood, wild-eyed and poised to run. It was her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“China Mae, where on earth have you been?” Mae asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged and looked down at her bare toes, unable to come up with a suitable answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae pushed the door open wide. “Well, come on in then,” she said softly. “And go wash,” she added. “Your clothes are filthy. What have you been doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nothing,” China mumbled and slipped past her mother on near silent bare feet.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Mae reached for her child, trying to brush the wayward ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("hair from her little girl’s face, but China was too fast. She was gone before she could catch her.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As Mae eased the door shut, she cast a nervous glance toward the living room on her way to the kitchen. Clyde was intent on the evening news and unaware that China was back. All she could do was hope that the meat loaf and mashed potatoes she’d fixed would sidetrack him from going on again about a broken cup.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Staying with Clyde bothered Mae’s conscience on a daily basis. It was one thing for her to tolerate Clyde’s abuse, but it shamed her that, by staying, she put China in danger, too. Yet leaving was even more frightening. She had no skills and a tenth-grade education, so her choice of jobs was never great. They needed Clyde’s paycheck to put a decent roof over their heads.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Inside the bathroom, China pulled the little step stool out from under the sink and stepped up on it so she could reach the faucets. The old pipes groaned as she opened the taps, and she flinched, certain that Clyde would come bursting through the door at any moment and give her a thrashing. In her haste to finish, a goodly portion of the water dribbled down the front of her dress, mingling with the dust to make thin streaks of mud. She swiped at the streaks with the palms of her hands, which only made things worse, and then she had to wash her hands again to get them clean. By the time she got to the kitchen, her legs were shaking and her stomach was in knots. She slipped into her chair without looking up, but she knew Clyde was ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("there—watching her, waiting for her to make another mistake.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you told her to wash up,” Clyde growled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China ducked her head as Mae turned, nervously clanking a spoon against the inside of the bowl in which she was dishing up the potatoes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae saw the smudges on her little girl’s face and dress, then looked past them to the stiff set of China’s shoulders and sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s fine. As soon as she’s had her supper, I’ll give her a bath.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde muttered beneath his breath, satisfied he’d made his point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae set the last bowl of food on the table, then slid into her chair with a heartfelt sigh and gave Clyde a tentative smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I made meat loaf.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde rolled his eyes as he stabbed at a roll. “Hell, woman, I can see that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae frowned, then shrugged. The way she looked at it, she’d made an overture of peace. If he didn’t want to accept it, then that was his problem, not hers. She reached for China’s plate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here, sweetie, Mama will fix your plate. Are you hungry?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China dared to look up. The scents surrounding her were varied and enticing, and had she not been so certain that Clyde wasn’t through with her, she might have done justice to the meal.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("She sighed and then fixed a dark, anxious gaze on her mother’s face.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not really,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Speak up, damn it,” Clyde yelled, and thumped the handle of his knife on the table, making the dishes and cutlery rattle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China flinched and moaned and gave her mother a frantic look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae’s frown deepened. “I heard her just fine,” she told Clyde. “Help yourself to the meat loaf and please pass it on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde grabbed the platter and defiantly slid over half the slices onto his plate before setting it back on the table with a thump. Then he reached across China’s plate for the bowl of mashed potatoes without caring that his elbow just missed hitting her in the nose. She started to slide out of the chair for a hasty exit when Clyde grabbed her by the arm and gave it a yank.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You sit,” he ordered, and then proceeded to spoon a huge portion of mashed potatoes onto her plate. “You ain’t gettin’ up until you eat every bite.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae reached for her daughter’s plate. “Clyde, you’ve given her too much. That’s even more than I could eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde backhanded Mae, catching the edge of her chin with his ring and leaving an angry gash that quickly started to seep a thin ribbon of blood.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("China gasped as her mother cried out, then held her breath, afraid that Clyde would take umbrage with her ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("response. Again she thought of the little brown caterpillar and wished she could just disappear.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde muttered an oath beneath his breath and grabbed a bowl of spinach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You got anything to say to me, whelp?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China shook her head vehemently, her eyes wide with fear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what I thought,” he muttered, then slid a helping of the dark, juicy greens onto her plate as Mae turned away to staunch the increasing flow of blood. Clyde picked up China’s fork and slapped it into the palm of her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eat!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China looked up to her mother for help, which angered Clyde even more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mama ain’t gonna help you this time,” he warned. “You eat or so help me God, I’ll whip your ass until you can’t sit down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae pivoted angrily. “You won’t touch my daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Convinced that if Clyde hit her mother again, he would kill her, China gave her stepfather a nervous glance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s all right, Mama,” she said quickly. “I can eat it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Across the room, Mae watched her baby girl and knew that, at that moment, China had more guts than she did, and it shamed her.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("China looked down at her plate, then up at Clyde as she stuck her fork in the top of the potatoes. An ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("uneasy silence filled the room as she lifted a bite to her lips and then closed her eyes.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly the back of her head exploded in pain as Clyde hit her with a doubled fist, driving her face into the plate of potatoes and spinach. She came up gasping for air as her fork clattered to the floor. In a panic, she began digging potatoes from her eyes and nose, knowing that to sit blind with the enemy was to taunt death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now look what you did, you ugly little bitch,” Clyde snarled, and yanked her up from the chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” Mae screamed, and dashed toward the table. But she wasn’t in time to prevent Clyde from dragging China from her seat and out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China was sobbing now, certain she was going to die.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t mean to break your cup. I didn’t mean to break your cup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Clyde was beyond reason. He hit the bathroom door with the flat of his hand and shoved China into the shower stall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mae was pounding on Clyde’s back with both hands, begging him to leave her baby alone, but he was mute to her pleas. He turned on the cold water faucet. Immediately water came spewing from the shower head and down onto his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In desperation, China kicked and screamed, begging for Clyde to stop, and in doing so, she accidentally kicked him in the eye. With a mighty roar, he grabbed her by the throat and turned her head up to the jets of chill water.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“I’ll teach you to mess with what’s mine,” he yelled. “I’m gonna wash that filth off your face if it’s the last thing I do.”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Clyde’s fingers tightened around China’s neck as her view of the world began to spin and then narrow dangerously. Water peppered into her eyes and up her nose, mingling with the tears and mashed potatoes. Choked sobs alternated with frantic gasps for air, and in her peripheral vision, she could just see an outline of her mother’s face and the footstool she was holding above her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then everything went black.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662fedcb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/pro.vue
// module id = 81
// module chunks = 0